import $ from 'jquery';

class StoryProgressBar {

  constructor() {
    this.progressContainer = $('.progress-container');
    if (this.progressContainer.length) {
      this.progressBar = $('.progress-bar');
      this.height = document.querySelector(".stories__wrapper").scrollHeight - 160;
      this.events();
    }
  }

  events(){
    let vm = this;
    $(document).on("scroll", function () {
      vm.updateScrollBar();
    });
  }

  updateScrollBar(){
    let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    let scrolled = ((winScroll / this.height) * 100) + 6;
    if (scrolled <= 101){
      this.progressBar.css('height', scrolled + "%");
      // this.progressContainer.attr("data-content", Math.round(scrolled) + "%");
    }
  }
}

export default StoryProgressBar;